import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  welcome__header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: "10px",
    backgroundColor: tokens.colorBrandForeground2,
  },
  hamburger: {
    color: tokens.colorNeutralBackground1,
    ":hover": {
      color: tokens.colorNeutralBackground2,
    },
  },
});
